export enum CarOwnerShipType {
  'Owned' = 'Owned',
  'Leased' = 'Leased',
  'Company' = 'Company',
}

export interface Car {
  ID: string;
  LoanApplicationID: string;
  TotalCostMonthly: number;
  OwnershipType: CarOwnerShipType;
}

export interface CreateCar {
  TotalCostMonthly: number;
  OwnershipType: CarOwnerShipType;
}

export interface UpdateCar extends Partial<Car> {
  ID: string;
}
